export default "__VITE_ASSET__e39585f3__"